export default __webpack_public_path__ + "static/media/SCADA2.519af945.gif";